const headerTools = {
    menu: $('.js_header__menu'),
    btn: $('.js_header__burger'),
    size: $(window).outerWidth() < 768 ? 'mob' : 'desk',

    open: function () {
        headerTools.menu.addClass('active')
        headerTools.btn.addClass('active')
    },

    close: function () {
        headerTools.menu.removeClass('active')
        headerTools.btn.removeClass('active')
    },

    toggle: function (btn) {
        if (btn.hasClass('active')) {
            headerTools.close()
        } else {
            headerTools.open()
        }
    },

    adapt: function () {
        if ($(window).outerWidth() < 768 && headerTools.size == 'desk') {
            headerTools.size = 'mob'
        } else if ($(window).outerWidth() >= 768 && headerTools.size == 'mob') {
            headerTools.size = 'desk'
            headerTools.close()
        }
    }
}

$(document).ready(() => {
    $(document).on('click', '.js_header__burger', function () {
        headerTools.toggle($(this))
    })

    $(window).on('resize', function () {
        headerTools.adapt($(this))
    })
})